//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name:'BreadCrumbs',
    props: ['breadCrumbs'],
};
